export interface ResetSelectionActionType {
  type: '@standard/RESET_SELECTION';
}

export const resetSelection = (): ResetSelectionActionType => ({
  type: '@standard/RESET_SELECTION',
});
